export enum TiposMutationNotificacao {
    SET_NOTIFICACOES = 'setNotificacoes',
}
